import {Validator} from './Validator';
import {ValidatorArray} from './ValidatorArray';

export class AllUnCheckedValidatorArray<T = any, E = Element> extends ValidatorArray<T, E> {
    constructor(value?: Validator<T, E>[], target?: E, event?: Event, autoValid = true) {
        super(value, target, event, autoValid);
    }

    valid(): boolean {
        return !((this.value ?? []).filter(it => it.checked).length > 0);
    }
}
